import { useState, useEffect } from 'react';

const useAutoUpdateInitialValues = (initialObj, dependencies = []) => {
  const [initialValues, setInitialValues] = useState(initialObj);

  useEffect(() => {
    if (!dependencies.every(dep => dep)) return;

    setInitialValues(prevState => ({
      ...prevState,
      ...dependencies.reduce((acc, dep) => {
        // Filter values to keep only keys present in initialObj
        const filteredDep = Object.keys(dep)
          .filter(key => initialObj.hasOwnProperty(key))
          .reduce((filtered, key) => {
            filtered[key] = dep[key];
            return filtered;
          }, {});
        
        return { ...acc, ...filteredDep };
      }, {})
    }));
  }, dependencies);

  return [initialValues, setInitialValues];
};

export default useAutoUpdateInitialValues;
